import { Outlet } from "react-router";
import "./Layout.scss";
import NavItems from "./NavItems";
import { AgxTypography } from "@urbanx/agx.ui-components2";

const Layout = () => {
  return (
    <div className="layout">
      <div className="layoutHeader">
        <AgxTypography id='layoutHeader' type='heading' size='large' color='#FFFFFF'>Dev and Release Tools 👨‍💻</AgxTypography>

        <NavItems />
      </div>

      <div className="layoutBody">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
